import React from 'react'
import BaseTooth from './BaseTooth'
import { ToothComponentProps } from './types/tooth.types'

/** Factory for crown-view tooth components (crown-top / crown-bottom). */
export const createToothCrown = (
  toothNumber: number,
  view: 'crown-top' | 'crown-bottom',
): React.FC<ToothComponentProps> => {
  const ToothComponent = (props: ToothComponentProps): React.ReactElement => {
    return <BaseTooth toothNumber={toothNumber} view={view} {...props} />
  }
  const viewSuffix = view === 'crown-top' ? 'CrownTop' : 'CrownBottom'
  ToothComponent.displayName = `Tooth${toothNumber}${viewSuffix}`
  return ToothComponent
}
